(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/components/popup-box-wrapper.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/components/popup-box-wrapper.js');
"use strict";


(function (svs, React, ReactRouterDOM) {
  'use strict';

  class PopupBoxWrapper extends React.Component {
    constructor(props) {
      super(props);
      this.handlePopupClose = this.handlePopupClose.bind(this);
      this.handlePopupBack = this.handlePopupBack.bind(this);
    }
    handlePopupClose(e) {
      e.preventDefault();
      this.props.history.push(this.props.closeNavigation);
    }
    handlePopupBack(e) {
      e.preventDefault();
      this.props.history.push(this.props.backNavigation);
    }
    render() {
      return React.createElement(svs.components.Popupbox, {
        onBack: this.handlePopupBack,
        onClose: this.handlePopupClose,
        portal: this.props.portalClassName,
        portalParent: this.props.portalParentId,
        title: this.props.title,
        url: this.props.url
      }, this.props.children);
    }
  }
  svs.grassroots_partner.PopupBoxWrapper = ReactRouterDOM.withRouter(PopupBoxWrapper);
})(svs, React, ReactRouterDOM);

 })(window);